import { z } from 'zod';
import { jerseyEntryIssues } from '@klothiq/domain';

const optionalText = z.string().nullable().optional();
export const jerseyDetailsV2Schema = z
  .object({
    team: z
      .object({
        id: z.string().uuid().nullable().optional(),
        entered_name: optionalText,
        classification: z.enum(['club', 'country']).nullable().optional(),
      })
      .strict()
      .nullable()
      .optional(),
    kit_key: optionalText,
    kit_other_label: optionalText,
    period: z
      .object({ kind: z.enum(['calendar_year', 'season']), value: z.string() })
      .strict()
      .nullable()
      .optional(),
    collection_key: optionalText,
    sleeve_key: optionalText,
    collar_key: optionalText,
    print_mode: z.enum(['no_name', 'named', 'customisable']).nullable().optional(),
    player_name: optionalText,
    shirt_number: optionalText,
    edition_key: optionalText,
    fit_key: optionalText,
    audience_key: optionalText,
    custom_design_text: optionalText,
  })
  .strict()
  .superRefine((value, ctx) => {
    for (const [field, message] of Object.entries(jerseyEntryIssues(value)))
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: [field], message });
  });
